export default __webpack_public_path__ + "media/images/table-2b0e9ea51258aeb8ffb9819a2e3703bd.png";